<script>
import mixinComponent from '../../Mixins/mixinComponent'

export default {
  mixins: [mixinComponent],

  props: {
    menuItem: { type: Object, required: true },
    menuName: { type: String, required: false },
  },

  computed: {
    styleClasses() {
      return Object.assign(
        {
          'topbar-submenu-link': !this.menuItem.icon,
          'topbar-contract-menu': !!this.menuItem.icon,
          'd-flex': true,
          'align-items-center': true,
          disabled: this.menuItem.disabled,
          'ml-1/2': !!this.menuItem.icon,
        },
        this.menuItem.classes ?? {},
      )
    },
  },
  methods: {
    dynamicLink() {
      this.$emit('navigate', this.menuItem.link)
    },
  },
}
</script>
<template>
  <div
    v-if="menuItem.show"
    :class="styleClasses"
    :title="$t(menuItem.name)"
    @click="dynamicLink"
    :e2e-button="menuName"
  >
    <div class="topbar-contract-circle" v-if="!!menuItem.icon || $slots.badge">
      <i v-if="menuItem.icon" :class="menuItem.icon"></i>
      <slot name="badge"></slot>
    </div>
    <span v-if="!menuItem.icon" :class="{ 'sub-active': menuItem.active }">{{ $t(menuItem.name) }}</span>
  </div>
</template>
